import React, { useEffect, useState } from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import processService from '../../services/process.service';

function EmailQueuePreviewModal({ show, queueId, onClose }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (!show || !queueId) {
            return;
        }

        setIsLoading(true);
        setError(null);
        setPreview(null);

        processService
            .getEmailQueuePreview(queueId)
            .then((res) => setPreview(res.data))
            .catch(() => setError('Failed to load email preview. The content may be missing or unavailable.'))
            .finally(() => setIsLoading(false));
    }, [show, queueId]);

    const handleClose = () => {
        setPreview(null);
        setError(null);
        onClose();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            backdrop="static"
            keyboard
            className="email-queue-preview-modal"
        >
            <Modal.Header closeButton={false}>
                <Modal.Title className="email-queue-preview-modal__title">
                    <i className="bi bi-envelope me-2"></i>
                    Email Preview
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                {isLoading && (
                    <div className="text-center py-5">
                        <Spinner animation="border" role="status" variant="primary" />
                        <p className="text-muted small mt-3 mb-0">Loading email content…</p>
                    </div>
                )}
                {!isLoading && error && (
                    <Alert variant="warning" className="m-3 mb-0">
                        {error}
                    </Alert>
                )}
                {!isLoading && preview && (
                    <>
                        <div className="px-3 py-2 border-bottom bg-light email-queue-preview-meta">
                            <div>
                                <strong>Subject:</strong> {preview.emailSubject || '—'}
                            </div>
                            <div className="text-muted">
                                <strong>To:</strong> {preview.receiver || '—'}
                                {preview.patientName ? (
                                    <>
                                        {' '}
                                        · <strong>Patient:</strong> {preview.patientName}
                                    </>
                                ) : null}
                            </div>
                            <p className="text-danger email-queue-preview-note mb-0 mt-2">
                                Preview only. Editing will not save anything.
                            </p>
                        </div>
                        <div
                            className="email-queue-preview-content p-3"
                            dangerouslySetInnerHTML={{ __html: preview.htmlContent }}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={handleClose}>
                    <i className="bi bi-x-lg me-1"></i>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EmailQueuePreviewModal;
